export enum OutletsEnum {
	summary = 'summary',
}
